import { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { ondemandSelector, setShowIncomingRequest } from "app/ondemandSlice";
import { Modal, Spinner } from "react-bootstrap";
import AuthService from "services/auth.service";
import OnDemandService from "services/on-demand.service";
import moment from "moment";
import CloseBtn from "assets/icons/Close-1.svg";
import "./TeleconsultOnDemand.scss";
import { useAudio } from 'app/OnDemandAlertContext';

export function IncomingRequestModal() {
  const dispatch = useDispatch();
  const isCancelled = useRef(false);
  const [loading, setLoading] = useState(false);
  const { play, pause } = useAudio();
  const { showIncomingRequest, incomingRequestData } =
    useSelector(ondemandSelector);

  useEffect(() => {
    return () => {
      isCancelled.current = true;
    };
  }, [dispatch]); // eslint-disable-line

  useEffect(() => {
    if(showIncomingRequest){
      play();
    }else{
      pause();
    }
    return () => {
      isCancelled.current = true;
    };
  }, [showIncomingRequest]); // eslint-disable-line

  const handleClose = () => {
    dispatch(
      setShowIncomingRequest({
        status: false,
        id: incomingRequestData.teleconsult_on_demand_id,
      })
    );
  };

  const handleAccept = () => {
    pause();
    setLoading(true);
    OnDemandService.accept({
      id: incomingRequestData.teleconsult_on_demand_id,
    }).then(
      (data) => {
        setLoading(false);
        const newWindow = window.open(`/eb/video?on_demand_id=${incomingRequestData.teleconsult_on_demand_id}`, '_blank', 'noopener,noreferrer');
        if (newWindow) newWindow.opener = null;
        handleClose();
      },
      (error) => {
        setLoading(false);
        if ([410,422,404].includes(error.response.status)) {
          handleClose();
          alert("Session is not available anymore");
        }
        if (error.response.status === 401) {
          AuthService.logout();
          window.location.replace("/eb/login");
        }
      }
    );
  };

  const getAge = (dateOfBirth) => {
    return moment().diff(dateOfBirth, "years", false);
  };

  return (
    <Modal
      className="modal-overlay incoming-request-modal"
      size="l"
      show={showIncomingRequest}
      backdrop="static"
      onHide={() => {
        handleClose();
      }}
      centered
    >
      <Modal.Header className="p-0">
        <button
          type="button"
          className="close close-button position-relative pb-0"
          onClick={() => {
            handleClose();
          }}
        >
          <img src={CloseBtn} alt="modal-close" className="w-30" />
        </button>
      </Modal.Header>
      <Modal.Body>
        <div>
          <div className="title">On-Demand Consultation Request</div>
          <div className="description">
            A patient requires immediate consultation. If you wish to consult
            with this patient, you can accept and begin the session now.
          </div>
          <div className="row info-container shadow">
            <img
              src={
                incomingRequestData?.profile_picture ||
                "https://beforeigosolutions.com/wp-content/uploads/2021/12/dummy-profile-pic-300x300-1.png"
              }
              alt="profile-img"
              className="info-container__image"
            />

            <div className="info-container__text">
              <div className="patient-details text-capitalize">
                {incomingRequestData?.first_name}{" "}
                {incomingRequestData?.last_name}, {incomingRequestData?.sex},{" "}
                {getAge(incomingRequestData?.date_of_birth)}yrs
              </div>
              {!incomingRequestData?.is_me && 
                <div className="sub-patient-details">
                  Patient: {[incomingRequestData?.visitor?.first_name, incomingRequestData?.visitor?.last_name].join(" ")}, {incomingRequestData?.visitor?.sex}, {getAge(incomingRequestData?.visitor?.date_of_birth)}yrs ({incomingRequestData?.visitor?.relationship})
                </div>
              }
              <div className="consultation-details">
                {incomingRequestData?.description}{" "}
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="flex-column button-footer">
        <button
          className="btn btn-link accept-button"
          type="submit"
          onClick={() => handleAccept()}
        >
          {loading ? (
            <div className="loader">
              <Spinner animation="border" className="spinner" />
            </div>
          ) : (
            <>Accept and Start Session</>
          )}
        </button>
        <button
          className={"btn btn-link reject-button"}
          type="submit"
          onClick={() => handleClose()}
        >
          {loading ? (
            <div className="loader">
              <Spinner animation="border" className="spinner" />
            </div>
          ) : (
            <>Reject</>
          )}
        </button>
      </Modal.Footer>
    </Modal>
  );
}

export default IncomingRequestModal;
